// extracted by mini-css-extract-plugin
module.exports = {"calTitleCustom":"BrokerageFee_calTitleCustom__37ijt"};